<template>
  <div class="content-wrapper">
    <Loader v-if="!plan.name" />
    <section v-if="plan.name" class="plan-info">
      <h2 class="impact-light plan-count">Plan: <strong>{{ plan.name }}</strong></h2>
      <p v-if="!plan.enabled" class="error">{{ $t("plan.archivedPlanHome.infoMsg") }}</p>
    </section>

    <Loader v-if="!groupsLoaded" />
    <h2 v-if="groupsLoaded" class="light group-count">Groups: <strong>{{ groups.length }}</strong></h2>
    <section v-if="groupsLoaded" class="cta-wrapper">
      <GroupBlock
        v-for="(group, index) in groups"
        v-bind:key="index"
        v-bind:group="group"
        v-bind:credits="credits"
        v-bind:planAdmin="planAdmin"
        v-bind:planEnabled="plan.enabled"
      />
    </section>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import GroupBlock from '@/components/plan/GroupBlock.vue'

import { planService } from '@/services/plan.service'
import { groupService } from '@/services/group.service'

export default {
  name: 'PlanHome',
  components: {
    Loader,
    GroupBlock
  },
  data () {
    return {
      planAdmin: true,
      showModal: false,
      planId: 0,
      plan: {},
      credits: 0,
      groups: [],
      groupsLoaded: false
    }
  },
  mounted: function () {
    this.planId = this.$route.params.planId

    this.fetchPlan()
  },
  methods: {
    fetchPlan: function () {
      // grab the plan
      planService.getPlan(this.planId).then(plan => {
        this.plan = plan
        if(plan.description){
          this.plan.description = decodeURIComponent(atob(plan.description))
        }
        this.fetchGroups()
        this.$forceUpdate()
      }).catch((err) => {
        if(err == 'User does not have permission for plan') {
          this.planAdmin = false
          planService.getPlanByMember(this.planId).then(plan => {
            this.plan = plan
            if(plan.description){
              this.plan.description = decodeURIComponent(atob(plan.description))
            }
          }).catch((err) => {
            console.error('Something went wrong fetching plan: ', err)
          })
          this.ownGroups()
        }
        else {
          console.error('Something went wrong fetching plan: ', err)
        }
      })
    },
    fetchGroups: function () {
      // Grab the groups (groups) for this plan.
      planService.getGroups(this.planId).then(groups => {
        let archivedGroups = []
        for(let group of groups){
          if(!group.enabled){
            if(group.description){
              group.description = decodeURIComponent(atob(group.description))
            }
            archivedGroups.push(group)
          }
        }
        this.groups = archivedGroups
        this.groupsLoaded = true
        this.$forceUpdate()
      }).catch((err) => {
        console.error('Something went wrong fetching groups: ', err)
      })
    },
    ownGroups: function () {
      groupService.getGroups().then(groups => {
        this.parseMemberGroups(groups)
        this.groupsLoaded = true
        this.$forceUpdate()
      }).catch((err) => {
        console.error('Something went wrong fetching own groups: ', err)
      })
    },
    parseMemberGroups: function (groups) {
      for(let group of groups) {
        if(group.planId === Number(this.planId)) {
          this.plan.name = group.planName
          this.groups.push(group)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.content-wrapper {
  .welcome {
    margin-bottom: 60px;
  }
}

section.plan-info {
  margin-bottom: 85px;
}
</style>
